<template>
  <div class=" seced-page w100">
    <div class="flex flex_items flex_center mb20">
      <el-input style="width: 400px;" class="mr20" v-model="keyword" placeholder="请输入订单号/票码/游客电话/游客身份证号"></el-input>
      <el-button type="primary" @click="search">搜索</el-button>
      <el-button @click="clear">清空</el-button>
    </div>
    <el-table :data="list" style="width: 100%" :header-cell-style="{
      background: '#F3F3F3',
      color: '#1F3349',
      fontSize: '15px',
      fontWeight: 'normal',
    }" :cell-style="{ fontSize: '15px', color: '#666666' }" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="50" :selectable="checkSelectable" />
      <el-table-column prop="ticket.name" label="门票名称" width="200" />
      <el-table-column prop="sn" label="票码" width="150" />
      <el-table-column prop="index" label="序号" width="80" />
      <!-- <el-table-column prop="play_date" label="支付时间" width="120" /> -->
      <el-table-column prop="price" label="单价" />
      <el-table-column prop="nickname" label="购买数">
        <template>1</template>
      </el-table-column>
      <!-- <el-table-column prop="tourist_name" label="游客姓名" />
      <el-table-column prop="tourist_phone" label="游客电话" />
      <el-table-column prop="tourist_code" label="游客证件号" /> -->
      <el-table-column prop="tourist_name" label="游客姓名" width="120">
        <template slot-scope="scope" v-if="scope.row.identities">
          <div v-for="(item, key) in scope.row.identities" :key="key">
            {{ item.tourist_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="infos.tourist_name" label="游客电话" width="150">
        <template slot-scope="scope" v-if="scope.row.identities">
          <div v-for="(item, key) in scope.row.identities" :key="key">
            {{ item.tourist_phone }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="infos.tourist_name" label="游客证件号" width="180">
        <template slot-scope="scope" v-if="scope.row.identities">
          <div v-for="(item, key) in scope.row.identities" :key="key">
            {{ item.tourist_code }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="tourist_code" label="门票状态">
        <template slot-scope="scope">
          {{ scope.row.status == 0 ? (scope.row.useNum == 0 ? '待使用' : '部分使用') : scope.row.status == 1 ? '已使用' :
            scope.row.status == -1 ? '已退款' : '' }}
        </template>
      </el-table-column>

      <div slot="empty" style="text-align: center;width:100%">
        暂无数据
      </div>
    </el-table>


    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :show-close="true" title="已退门票"
      :visible.sync="dialogVisible" width="30%">
      <div class="flex flex_items f20 mb24">
        <div v-for="(item, index) in reList" :key="index">
          {{ item.sn }}、{{ item.ticket ? item.ticket.name : '' }}
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
export default {
  props: {
    type: {
      reason: ''
    }
  },
  data() {
    return {
      keyword: '',
      list: [],
      choseArr: [],
      dialogVisible: false,
      reList: []
    }
  },
  methods: {
    makeup() {
      if (this.choseArr.length == 0) return this.$message.error('请选择要退款的门票');
      let ids = this.choseArr.map(r => {
        return r.id
      })
      this.$confirm('确定退款选中的门票？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: "warning"
      }).then(() => {
        this.api.postUrl('/api/v1/window/order/refund/ticket', { ids: ids, reason: this.reason }, { loading: true })
          .then((res) => {
            // this.$message.success('操作成功');
            this.dialogVisible = true;
            this.clear()
            this.reList = res;
          });
      });

    },
    search() {
      this.api.getUrl('/api/v1/window/order/refund/ticket', { keyword: this.keyword }, { loading: true }).then(res => {
        this.list = res
      })
    },
    handleSelectionChange(e) {
      this.choseArr = e;
    },
    clear() {
      this.keyword = '';
      this.list = []
    },
    checkSelectable(row, index) {
      return row.status == '0' && row.useNum == 0;
    },
  },
  created() {
    this.keyword = this.$route.query.search ? this.$route.query.search : ''
  }
}
</script>
<style scoped>
.demo-ruleForm {
  width: 400px;
}
</style>